import { Component, Inject, OnInit, ViewChild } from '@angular/core';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';
import { FolderTreeComponent } from 'projects/apex/src/app/components/folder/tree/tree.component';
import { t } from '../../translate/translate.function';

@Component({
  selector: 'apex-folder-tree-dialog',
  templateUrl: './dialog.component.html',
})
export class FolderTreeDialogComponent implements OnInit {
  @ViewChild(FolderTreeComponent) tree: FolderTreeComponent;

  buttonLabel = t('Move');

  constructor(
    @Inject(MAT_DIALOG_DATA) public data: { label?: string },
    public ref: MatDialogRef<FolderTreeDialogComponent>,
  ) {
    if (data?.label) {
      this.buttonLabel = data.label;
    }
  }

  ngOnInit(): void {
    this.ref?.addPanelClass(['apex-fullscreen-dialog', 'phone']);
  }

  confirm(): void {
    this.ref.close({
      folder: this.tree.folder,
    });
  }

  get disabled(): boolean {
    return (
      !this.tree?.folder ||
      this.tree?.folder?.modelName === 'upload' ||
      this.tree?.folder?.id === 'home' ||
      this.tree?.folder?.id === 'share'
    );
  }
}
